<template>
  <el-popover placement="bottom" trigger="click" :visible-arrow="false" width="240">
    <div class="details">
      <div class="info">
        <p class="text_size_16">{{avatarInfo.username}}</p>
        <i v-if="false" class="iconfont icon-huiyuan" style="color: #F0E429;" />
      </div>
      <div class="real_name text_size_12 text_weight_bold text_color_active">
        <span>{{avatarInfo.real_name === '' ? '未实名' : avatarInfo.real_name}}</span>
      </div>
    </div>
    <ul class="avatar_popover">
      <router-link to="/user" tag="li" class="avatar_popover_item">
        <i class="iconfont icon-gerenshezhi item_icon" />
        <span class="item_text text_size_12">账号管理</span>
      </router-link>
      <router-link to="/user/record" tag="li" class="avatar_popover_item">
        <i class="iconfont icon-jibenxinxi item_icon" />
        <span class="item_text text_size_12">基本信息</span>
      </router-link>
    </ul>
    <div class="sign_out">
      <el-button size="small" class="sign_out_button" @click="signOut">
        退出学识云平台
      </el-button>
    </div>
    <!-- 头像 -->
    <div id="avatar" slot="reference" class="avatar">
      <el-avatar :size="32" :src="avatarInfo.avatar_url"></el-avatar>
    </div>
  </el-popover>
</template>

<script>
import * as api from '~/api'
import cookie from '~/utils/cookie'
import { getLoginPath } from '~/utils/assist'
export default {
  data () {
    return {
      data: {}
    }
  },
  props: {
    // 用户的信息
    avatarInfo: {
      type: Object,
      default: () => {
        return ({})
      }
    }
  },
  methods: {
    // 获取个人信息
    getAccountInfo () {
      api.getAccountInfo().then(res => {
        if (res.data.code === 0) {
          this.data = res.data.data
          this.$store.commit('SET_USER_INFO', res.data.data)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 退出登录
    signOut () {
      api.signOut().then(res => {
        cookie.remove('token')
        cookie.remove('device_id')
        location.href = getLoginPath()
      }).catch(err => {
        cookie.remove('token')
        cookie.remove('device_id')
        location.href = getLoginPath()
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 100px;
  &:hover {
    background-color: $--color-primary-light-9;
    cursor: pointer;
  }
}
.details {
  display: flex;
  flex-direction: column;
  padding: 24px 20px 0 17px;
  .info {
    display: flex;
    height: 20px;
    justify-content: space-between;
    align-items: center;
  }
  .real_name {
    display: flex;
    height: 20px;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
.avatar_popover {
  border-top: 1px solid $border-color-base;
  .item_icon {
    color: $color-primary;
  }
  .item_text {
    padding-left: 20px;
  }
  &_item {
    line-height: 40px;
    display: flex;
    align-items: center;
    padding-left: 20px;
    &:hover {
      background-color: $--color-primary-light-9;
      cursor: pointer;
    }
  }
}
.sign_out {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/header/avatar.vue